import {Component, Input, OnInit, Output} from '@angular/core';
import {CollectionParams} from "../../helpers/params/collection-params";
import {paramsHelper} from "../../helpers/params-helper";
import {E_ENDPOINTS} from "../../helpers/params/loader-params";
import {CollectionService} from "../../services/collection.service";
import {IDocument} from "../../interfaces/document.definition";
import {SearchController} from "../../helpers/search-controller";
import {NavigationState} from "../../helpers/navigation-state";
import {getUtcTime, processTemplateString} from "../../utils";
import {BusService} from "../../services/bus.service";
import {ISearchParam} from "../../definitions";
import {SEARCH_PROP_TYPES} from "../../enums/e-search";

@Component({
  selector: 'app-nv-logs',
  templateUrl: './nv-logs.component.html',
  styles: []
})
export class NvLogsComponent implements OnInit {

  logsList:ILog[];
  nav:NavigationState;
  searchController:SearchController;

  private selected:ILog;
  private _collectionParams: CollectionParams;

  @Input() set collectionParams(v: CollectionParams) {
    this._collectionParams = v;
    this.searchController.setParams(v.getSearchParams(), v.getFilterParams());
  }

  get collectionParams(): CollectionParams {
    return this._collectionParams;
  }

  constructor(private collectionService:CollectionService,
              private busService:BusService)
  {
    this.searchController = new SearchController(() => this.loadLogsList());
    this.nav = new NavigationState(() => this.loadLogsList());
  }

  ngOnInit()
  {
    this.loadLogsList();
  }

  loadLogsList()
  {
    const params = paramsHelper.loader()
      .setEndpointId(E_ENDPOINTS.LOGS)
      .setAdditionalParam("target", this.collectionParams.getTarget())
      .setNavParams(this.nav.offset, this.nav.limit)
      .setSortParams([{property:"time", order:-1}/*{property:"_id", order:-1}, {property:"data.time", order:-1}*/])
      .setSearchParams(this.searchController.collectSearchParams());

    this.collectionService.loadChunk(params)
      .subscribe(result =>
      {
        this.logsList = result.documents as ILog[];
        this.nav.update(result.offset, result.count);
      });
  }

  getDocumentLabel(item: IDocument): string {
    return processTemplateString(this.collectionParams.getItemLabel(), item);
  }

  onSelect(log:ILog)
  {
    this.selected = log;
    this.busService.emitDocumentUpdated(
      {
        document: log as IDocument,
        readonly: true,
        user: <any>{displayName: "system"}
      }
    );
  }

  isCurrentDocument(log:ILog): boolean {
    return this.selected &&
      this.selected._id === log._id;
  }

  getUtcTime(time:number):string
  {
    return getUtcTime(time);
  }

  isValidNumber(val:number):boolean
  {
    return !isNaN(val);
  }

}

export interface ILog{
  _id:string;
  userId:string;
  tag:string;
  message:string;
  data:object;
  time:number;
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-logs/nv-logs.component.ts